import script from "./NoticeCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeCreateView.vue?vue&type=script&setup=true&lang=js"

import "./NoticeCreateView.vue?vue&type=style&index=0&id=81952418&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81952418"]])

export default __exports__